<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="userForm"
          :model="userForm"
          :rules="rules"
          label-width="120px"
          style="width: 90%"
        >
          <el-form-item label="旧密码" prop="oldPwd">
            <el-input
              v-model="userForm.oldPwd"
              show-password
              clearable
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPwd">
            <el-input
              v-model="userForm.newPwd"
              show-password
              clearable
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="newPwd2">
            <el-input
              v-model="userForm.newPwd2"
              show-password
              clearable
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button type="primary" @click="OnConfirm('userForm')"
          >确认</el-button
        >
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import ZJUser from "../user";
import ZJApis from "../api";
export default {
  name: "ZjChangePasswd",
  data() {
    let validateNewPassword = (rule, value, callback) => {
      if (value === this.userForm.oldPwd) {
        callback(new Error("新密码不能与原密码相同!"));
      } else {
        callback();
      }
    };
    let validateNewPassword2 = (rule, value, callback) => {
      if (value !== this.userForm.newPwd) {
        callback(new Error("与新密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      userForm: {
        oldPwd: "",
        newPwd: "",
        newPwd2: "",
      },
      rules: {
        oldPwd: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validateNewPassword, trigger: "blur" },
        ],
        newPwd2: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: validateNewPassword2, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    OnConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ChangePassword();
        } else {
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    ChangePassword() {
      const loginInfo = {
        LoginName: ZJUser.current.UserName,
        OldLoginPwd: this.userForm.oldPwd,
        LoginPwd: this.userForm.newPwd,
      };
      new ZJApis.UserApi()
        .ChangePassword(loginInfo)
        .then((r) => {
          r = r.data.Data;
          if (r) {
            this.$message({
              type: "success",
              message: "密码修改成功！",
            });
            this.logInfo.ActionName = "修改密码";
            this.logInfo.LogMessage = "修改密码成功";
            this.logInfo.ModuleName = "登录";
            this.logInfo.PageName = "修改密码";
            this.addOperationLog();
            this.$emit("clickCancel", {});
          } else {
            this.$message({
              type: "error",
              message: "密码修改失败！",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
};
</script>

<style></style>
